import React, { FC, useState, useEffect } from 'react';
import { useTranslation } from '@blocs.i18n';
import { useHistory, useLocation } from 'react-router-dom';
import Modal from '@minecraft.modal';
import { useRouteParams } from '@minecraft.utils';
import { useGlobalNotification } from '@minecraft.notification-provider';
import { CLAIM_ACCOUNT_STEP, ModalProps } from './types';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';

type Props = ModalProps;

const ClaimAdditionalAccountModal: FC<Props> = ({ isOpen, close, handleDivisionChange }) => {
  const { t } = useTranslation();
  const { showMessage } = useGlobalNotification();
  const { isFromOnboarding, organizationId, isAdditionalAccount } = useRouteParams();
  const history = useHistory();
  const location = useLocation();
  const [step, setStep] = useState<CLAIM_ACCOUNT_STEP>(CLAIM_ACCOUNT_STEP.SELECT_COUNTRY);
  const onClose = () => {
    setStep(CLAIM_ACCOUNT_STEP.SELECT_COUNTRY);
    close();
  };

  useEffect(() => {
    if (isFromOnboarding) {
      history.replace(location.pathname);
    }

    if (organizationId) {
      const id = Number(organizationId);
      handleDivisionChange(id);
    }

    if (isFromOnboarding) {
      showMessage({
        message: isAdditionalAccount
          ? t('common:toast.addlAccountClaimSuccess')
          : t('common:toast.accountClaimSuccess'),
        color: 'success',
      });
    }
  }, [isFromOnboarding, isAdditionalAccount]);

  return (
    <Modal
      isOpen={isOpen}
      title={<ModalHeader step={step} setStep={setStep} />}
      submitLabel={t('common:button.noThanks')}
      isFooterHidden={step !== CLAIM_ACCOUNT_STEP.SELECT_COUNTRY}
      handleToggleClick={onClose}
      handleSubmitClick={onClose}
      modalSize="medium"
      data-testid="claim-additional-account-modal"
    >
      <ModalBody step={step} setStep={setStep} />
    </Modal>
  );
};

export default ClaimAdditionalAccountModal;
